import { IDeviceStatus } from "@types"
import { protectedApi } from "store/Api"

const devicesStatus = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        deviceStatus: builder.query<IDeviceStatus[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devices/status`,
                }
            },
        }),
    }),
})

export const { useDeviceStatusQuery } = devicesStatus
